import React from 'react';
import { TextField, Box, makeStyles, Typography } from '@material-ui/core';
import TranslateIcon from '@material-ui/icons/Translate';

const useStyles = makeStyles((theme) => ({
  container: {
    background: theme.palette.background.default,
    borderRadius: 16,
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}` },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
    '& svg': {
      fontSize: 20,
      color: theme.palette.primary.main }
  },
  headerTitle: {
    fontWeight: 600,
    fontSize: '0.95rem' },
  field: {
    marginBottom: theme.spacing(2.5),
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 12,
      color: theme.palette.text.primary },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.secondary },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main },
    '& .MuiInputLabel-outlined': {
      color: theme.palette.text.secondary },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: theme.palette.primary.main } },
  arabicField: {
    '& .MuiInputBase-root': {
      direction: 'rtl',
      fontFamily: '"Traditional Arabic", "Scheherazade New", serif',
      fontSize: '1.2rem' } } }));

export default function MultiLangTextField({ fields, onChange, label, maxRows = 6, helperText, title = 'Multilingual Inputs' }) {
  const classes = useStyles();
  
  const langKeys = Object.keys(fields);
  const langLabels = { en: 'English Translation', bn: 'Bangla Translation', ar: 'Arabic Text' };

  return (
    <Box className={classes.container}>
      <div className={classes.header}>
        <TranslateIcon />
        <Typography className={classes.headerTitle}>{title}</Typography>
      </div>
      {langKeys.map((key) => (
        <TextField
          key={key}
          fullWidth
          variant="outlined"
          label={langLabels[key] || `${label} (${key})`}
          placeholder={label === 'Prophet Name (English & Bangla)' ? (key === 'en' ? 'e.g. Muhammad' : 'যেমন: মুহাম্মদ') : (key === 'en' ? 'Enter text in English' : 'বাংলায় টেক্সট লিখুন')}
          helperText={helperText?.[key] || ''}
          value={fields[key] || ''}
          onChange={(e) => onChange({ ...fields, [key]: e.target.value })}
          className={`${classes.field} ${key === 'ar' ? classes.arabicField : ''}`}
          dir={key === 'ar' ? 'rtl' : 'ltr'}
          multiline={true}
          minRows={2}
          maxRows={maxRows}
          style={{ resize: 'vertical' }}
          InputProps={{
            style: { direction: key === 'ar' ? 'rtl' : 'ltr' } }}
        />
      ))}
    </Box>
  );
}
